import facebook from 'global/images/verification/facebook.png';
import youtube from 'global/images/verification/youtube.png';
import twitter from 'global/images/verification/twitter.png';
import tiktok from 'global/images/verification/tiktok.png';
import instagram from 'global/images/verification/instagram.png';

export const socialImages = { facebook, youtube, twitter, tiktok, instagram };

export default socialImages;
